"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_polyglot_1 = require("react-polyglot");
const LabelUtils_1 = __importDefault(require("./LabelUtils"));
class PolyglotWrapper {
}
PolyglotWrapper.t = (label, data) => {
    const customLabel = LabelUtils_1.default.customize(label, data);
    if (data) {
        return react_polyglot_1.Polyglot.t(customLabel, (data === null || data === void 0 ? void 0 : data.data) || data);
    }
    if (customLabel) {
        return react_polyglot_1.Polyglot.t(customLabel);
    }
    return customLabel;
};
exports.default = PolyglotWrapper;
